import { DefaultOptionType } from "antd/es/select";
import { loadPersonsOptions } from "src/components/PersonSelect/loadPersonsOptions";
import { ZAttribute } from "src/types/ZAttribute";
import { EntityCardData } from "src/pages/EntityCardPage/EntityCardStore";
import { getEditorInfo } from "src/common/attrEdit";
import { ZUid } from "src/types/zUid";
import { chatGetRequiredUsersIds } from "./NewChatButton/getRequiredUserIds";

const rolesRequestCache: Record<string, Promise<DefaultOptionType[]>> = {};
const makeKey = (attr: ZAttribute, ids: ZUid[]) =>
  `${attr.id}-${ids.join("-")}`;

const getRolesViewAttrs = (attr: ZAttribute) => {
  const editor = getEditorInfo(attr.viewStyles);
  if (editor?.component && "rolesViewAtts" in editor.component) {
    return editor.component.rolesViewAtts ?? undefined;
  }
  return undefined;
};

const getCached = async (attr: ZAttribute, ids: ZUid[], objectId: ZUid) => {
  const cacheKey = makeKey(attr, ids);
  let request = rolesRequestCache[cacheKey];
  if (request) return request;
  request = loadPersonsOptions([], objectId, ids, getRolesViewAttrs(attr));
  rolesRequestCache[cacheKey] = request;
  return request;
};

interface ParamsGetRolesCachedRequest {
  attr: ZAttribute;
  cardData: EntityCardData;
  isDisabled: (id: ZUid) => boolean;
  selectedIds: ZUid[];
  objectId: ZUid;
}

export const getRolesCachedRequest = async (
  params: ParamsGetRolesCachedRequest,
): Promise<DefaultOptionType[]> => {
  const { attr, cardData, isDisabled, selectedIds, objectId } = params;
  const ids = [...selectedIds, ...chatGetRequiredUsersIds(cardData)];
  const requestAttr = { ...attr, roleIds: undefined };
  return getCached(requestAttr, ids, objectId).then((data) =>
    data
      .map((opt) => ({
        ...opt,
        disabled: isDisabled(String(opt.value)),
      }))
      .sort((a, b) => Number(b.disabled) - Number(a.disabled)),
  );
};
